<template>
  <div class="qmk button ghost" v-if="getCurrentDevice.isQMKDevice" @click="openVIA">
    <span class="title">QMK{{ $t('software') }}</span>
  </div>
</template>

<script setup lang="ts">
import { Brand, getBrand } from '@/brand/brand'
import { getCurrentDevice } from '@/profiles/selector'
import { openExternalLink } from '@/tool/utility'
const openVIA = async () => {
  const bd = await getBrand()
  if (bd === Brand.irok) {
    openExternalLink('https://via.irok.cn')
  } else {
    openExternalLink('https://via.iyx.fun')
  }
}
</script>
<style lang="less" scoped>
.qmk {
  position: fixed;
  right: 30px;
  top: 90px;
  height: 42px;
  padding: 0 16px;
  z-index: 100;

  .title {
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
